import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DIALOG_DATA, DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent, InfoDialogContentComponent } from '@iw/common';
import { DialogData } from '@iw/core/entities';
import { environment } from '@iw/environment';

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  note?: string;
  confirmText?: string;
  cancelText?: string;
  iconName?: string;
  supportBtn?: boolean;
  status?: 'succeeded' | 'failed' | 'pending';
}

@Component({
  selector: 'iw-confirm-dialog',
  styleUrl: './confirm-dialog.component.scss',
  templateUrl: './confirm-dialog.component.html',
  imports: [
    IconModule,
    ButtonComponent,
    TranslateModule,
    InfoDialogContentComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  readonly #dialogRef = inject(DialogRef);
  readonly #dialogData = inject<
    DialogData<ConfirmDialogComponent, ConfirmDialogData>
  >(DIALOG_DATA, { optional: true });
  readonly data = this.#dialogData?.data;

  readonly title = this.data?.title ?? 'confirmDialog.title';
  readonly message = this.data?.message ?? 'confirmDialog.message';
  readonly note = this.data?.note;
  readonly confirmText = this.data?.confirmText ?? 'confirmDialog.btn.confirm';
  readonly cancelText = this.data?.cancelText ?? 'confirmDialog.btn.cancel';
  readonly status = this.data?.status ?? 'failed';
  readonly iconName = this.data?.iconName ?? '';
  readonly supportBtn = this.data?.supportBtn ?? false;

  readonly supportLink = environment.supportLink;

  confirm() {
    this.#dialogRef.close(true);
  }

  cancel() {
    this.#dialogRef.close();
  }

  openSupport(): void {
    window.open(this.supportLink, '_blank', 'noopener,noreferrer');
  }
}
